import {subscribe} from "../kongApiCommon";
import {getCustomFields} from "../forms/subscribeCustomFields"

export const subscribeToManyLists = (email, mailingLists, auth, domain, source, data, trackingData) => {
    mailingLists.forEach(list => subscribe(email, list, auth, domain, source, getCustomFields(data, list), trackingData));
};
